/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the data values to consider:
 *   * INITIAL_CORRECTED : work with the corrected values where possible, otherwise the initially acquired values if it has not been corrected
 *   * INITIAL_ONLY : work only with the initially acquired values
 *   * CORRECTED_ONLY : work only with the corrected values
 */
export enum GraphDataValueType {
  INITIAL_CORRECTED = 'INITIAL_CORRECTED',
  INITIAL_ONLY = 'INITIAL_ONLY',
  CORRECTED_ONLY = 'CORRECTED_ONLY'
}
